function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("g", {
  strokeWidth: 1.002
}, /*#__PURE__*/React.createElement("path", {
  d: "M21 7.5h10v10H21z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 26,
  cy: 12.5,
  r: 3
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.16 1.1l5.857 6.4h-12zM18 17.502h16V21.5H18zM21 21.5h10l2 27.3H19z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M5 54.5s5-5.8 21-5.8 21 5.8 21 5.8zM20.6 29L31 24M20.4 32l11.1-5.5M20.072 36.736l11.481-5.772M19.853 40.019L32 33.7M19.3 45L32 38M19 48l13.4-7"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.264 12h-3M18 14l-2.236 2M18 10l-2.236-2"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M34.834 12h3M34.098 14l2.236 2M34.098 10l2.236-2"
}));

var SvgLighthouse = function SvgLighthouse(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLighthouse, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Lighthouse.90720d74.svg";
export { ForwardRef as ReactComponent };